import { Landmark } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/** Pill marking an object as belonging to a political advertiser. */
export function PoliticalBadge({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-(--ad-primary-subtle) px-2 py-0.5 text-xs font-medium text-(--ad-primary)',
        className
      )}
    >
      <Landmark className="size-3" />
      {t('advertisers.political')}
    </span>
  )
}
